<template>
  <div
    class="p-8 md:p-16 flex-grow"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CoreContentArea',
};
</script>
